export default __webpack_public_path__ + "img/b1331adf411735a70204903bf123830b.svg";